import { render, staticRenderFns } from "./inputCheckbox.pug?vue&type=template&id=862684fa&lang=pug&external"
import script from "./inputCheckbox.js?vue&type=script&lang=js&external"
export * from "./inputCheckbox.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Multiasistencia\\selfcare\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('862684fa')) {
      api.createRecord('862684fa', component.options)
    } else {
      api.reload('862684fa', component.options)
    }
    module.hot.accept("./inputCheckbox.pug?vue&type=template&id=862684fa&lang=pug&external", function () {
      api.rerender('862684fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/input/modules/checkbox/index.vue"
export default component.exports